import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'
import { fieldNames } from '../../constants'
import { churchRecordNumberFieldString } from '../../commonStrings'

export default function ChurchRecordNumberTextField(props) {
  const { t } = useTranslation()
  return (
    <FormTextField
      id="church-record-number"
      type="text"
      autoComplete="off"
      name={fieldNames.churchRecordNumber}
      label={churchRecordNumberFieldString()}
      helpMessage={
        <>
          <span>{t('how-to-find-church-record-number.item1', 'Ask the ward clerk or bishopric.')}</span>
          <br />
          <span>{t('how-to-find-church-record-number.item2', 'Look on your temple recommend.')}</span>
        </>
      }
      {...props}
    />
  )
}
